export const content = `To add a secondary insurance, you must already have a primary insurance added to your account. Otherwise, the information you put in for your secondary insurance will be used as your primary.

**To learn how to update your primary insurance, [use this help article](/support/articles/how-do-i-update-my-insurance-information).**

In your email, you received an estimate of your session costs—but this only considers your primary insurance. To find out how much your secondary insurance will pay for, contact them directly.

## On mobile

1. When you login to your account, use the ![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXdgoymwTkYsmurHJwftDW8M2h4hzVGm5wlW3lapEu9YAloECp3nwNvB51DMKwdeMA0zur3hMiBw-CLaXV3C0MX0XK0rf5wtu0X_vF3zul2IDWIJUk6QNV535m8ge2Pol0-jpYQE6w?key=CRFWHqpHXz1EuwOLvDfBHFv7) icon to open your navigation menu.
2. Select [**Insurance**](/insurance).
3. Scroll down to **Have Another Insurance?**
4. Select **Add Insurance**.
5. Add information about your health plan, including your provider and member ID.
6. Upload a photo of the front and back of your insurance card.
7. Confirm whether or not you’re the Primary Subscriber. If you’re not, enter their information.
   - If you were added to your insurance plan by someone else, you might not be the primary subscriber.
     The primary subscriber is the main person on the insurance plan. Also called the "policy holder," this person owns the plan because they might pay the premiums for it or they get insurance through work.
8. Select **Save**.

## On desktop

1. When you login to your account, go to [**Insurance**](/insurance) from your sidebar navigation.
2. If you already have insurance information, use **Edit**. Otherwise, select Add Insurance.
3. Scroll down to **Have Another Insurance?**
4. Select **Add Insurance**.
5. Add information about your health plan, including your provider and member ID.
6. Upload a photo of the front and back of your insurance card.
7. Confirm whether or not you’re the Primary Subscriber. If you’re not, enter their information.
   - If you were added to your insurance plan by someone else, you might not be the primary subscriber.
     The primary subscriber is the main person on the insurance plan. Also called the "policy holder," this person owns the plan because they might pay the premiums for it or they get insurance through work.
8. Select **Save**.
`;
